/**
 * @deprecated Only used to show a label in the PhotoUploadComponent.
 */
export enum PhotoType {
    CHECKUP = 'checkup',
    DAMAGE = 'damage',
    ISSUE_REPORT = 'issueReport',
}
